import { IListEntity } from "@/v1/types/global";
import { ITask } from "@/v2/types/Task/Task.interface";
import { apiClient } from "@/v2/utils/apiClient";

export const getTasks = (query?: string, httpclient = apiClient) => {
  return httpclient.get<IListEntity<ITask>>(`/api/v2/tasks/me?${query}`);
};

export const cancelTask = (id: string | number, httpclient = apiClient) => {
  return httpclient.post(`/api/v1/tasks/${id}/cancel`);
};
